import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import { menuItems } from '../../mocks/menuData';

export default function MenuPage() {
  const [selectedCategory, setSelectedCategory] = useState('Todos');

  const categories = ['Todos', 'Bocadillos', 'Durum', 'Pizzas Lawasa', 'Platos', 'Raciones', 'Menús', 'Menús Fried Chicken', 'Bebidas'];

  const filteredItems = selectedCategory === 'Todos' 
    ? menuItems 
    : menuItems.filter(item => item.category === selectedCategory);

  return (
    <div className="min-h-screen bg-[#E63946]">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6 lg:px-20 bg-gradient-to-br from-[#E63946] to-[#D62839]">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-block bg-white/20 px-4 py-2 rounded-full mb-6">
            <p className="text-white font-semibold text-sm">NUESTRO MENÚ</p>
          </div>
          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
            Descubre nuestros <span className="text-white/90">sabores</span>
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Menús completos, ofertas especiales y mucho más. Todo preparado al momento con ingredientes frescos
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 px-6 lg:px-20 bg-[#E63946] sticky top-20 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-white text-[#E63946] shadow-lg scale-105'
                    : 'bg-white/20 text-white hover:bg-white/30'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Menu Grid */}
      <section className="py-16 px-6 lg:px-20 bg-[#E63946]">
        <div className="max-w-7xl mx-auto">
          {/* Category Title */}
          <div className="mb-12">
            <h2 className="text-4xl font-bold text-white mb-2">
              {selectedCategory === 'Todos' ? 'Todo el Menú' : selectedCategory}
            </h2>
            <p className="text-white/80">
              {filteredItems.length} {filteredItems.length === 1 ? 'producto' : 'productos'}
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredItems.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group"
              >
                {/* Image */}
                <div className="relative h-64 w-full overflow-hidden bg-gray-100">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  {/* Category Badge */}
                  <div className="absolute top-4 left-4 bg-[#E63946] text-white px-4 py-2 rounded-full text-sm font-semibold">
                    {item.category}
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    {item.name}
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {item.description}
                  </p>
                  
                  {/* Price and CTA */}
                  <div className="flex items-center justify-between">
                    <span className="text-3xl font-bold text-[#E63946]">
                      {item.price}
                    </span>
                    <a
                      href="tel:919123048"
                      className="bg-[#E63946] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#D62839] transition-all hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
                    >
                      <i className="ri-phone-fill"></i>
                      Pedir
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Empty State */}
          {filteredItems.length === 0 && (
            <div className="text-center py-20">
              <i className="ri-restaurant-line text-6xl text-white/30 mb-4"></i>
              <p className="text-xl text-white/70">No hay productos en esta categoría</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 lg:px-20 bg-gradient-to-br from-[#D62839] to-[#C41E3A]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            ¿Listo para hacer tu pedido?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Llámanos ahora y recoge tu pedido en minutos
          </p>
          <a
            href="tel:919123048"
            className="inline-flex items-center gap-3 bg-white text-[#E63946] px-12 py-5 rounded-full text-xl font-bold hover:bg-gray-100 transition-all hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-2xl"></i>
            919 123 048
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
